export  default {
    setPermAreas(state, payload) {
        state.permAreas = payload;
      },
    setPermArea(state, payload) {
        state.permArea = payload;
      },
   
};